import { Boxes, Lightbulb, PanelTop, Send, ShieldUser, UserStar } from "lucide-react";
import { scrollToSection, useLandingActions } from "./useLandingActions";

export type PublicNavLink = { id: string; label: string };

const defaultLinks: PublicNavLink[] = [
    { id: "programs", label: "Programs" },
    { id: "stories", label: "Stories" },
    { id: "faq", label: "FAQ" },
    { id: "contact", label: "Contact" },
];

export default function PublicNav({ links = defaultLinks, homeHref }: { links?: PublicNavLink[]; homeHref?: string }) {
    const { signIn } = useLandingActions();

    const navigate = (id: string) => {
        scrollToSection(id);
    };

    const iconFor = (id: string) => {
        if (id === "programs" || id.includes("workshop") || id.includes("internship") || id === "availability") return <Boxes />;
        if (id === "stories") return <UserStar />;
        if (id.includes("faq")) return <Lightbulb />;
        if (id === "contact") return <Send />;
        return <PanelTop />;
    };

    return <>
        <nav className="mz-nav" aria-label="Main navigation">
            <div className="mz-container mz-nav__inner">
                <button className="mz-brand" onClick={() => homeHref ? window.location.assign(homeHref) : navigate("home")} aria-label="MockZo home">
                    <img src="/images/jpg/mockzo-logo-v3.webp" alt="" aria-hidden="true" className="mz-brand__mark" />
                    <span>MockZo</span>
                </button>
                <div className="mz-nav__links">
                    {links.map((link) => <button key={link.id} onClick={() => navigate(link.id)}>{link.label}</button>)}
                </div>
                <div className="mz-nav__actions">
                    <button className="mz-button mz-button--primary mz-nav__signin" onClick={signIn}>Sign In/up</button>
                </div>
            </div>
        </nav>
        <div className="mz-mobile-bottom-nav" aria-label="Mobile navigation">
            {links.slice(0, 4).map((link) => <button key={link.id} type="button" onClick={() => navigate(link.id)} aria-label={link.label} title={link.label}>{iconFor(link.id)}</button>)}
            <button type="button" onClick={signIn} aria-label="Sign In/up" title="Sign In/up"><ShieldUser /></button>
        </div>
    </>;
}
